import React from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast'; 


const Topbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear cookies
    Cookies.remove('adminToken');
    
    // Clear localStorage/sessionStorage
    localStorage.clear();
    sessionStorage.clear();
     toast.success('Logged out successfully');

    // Redirect to login
     setTimeout(() => {
      navigate('/admin');
    }, 1000); // delay for user to see the toast
  };
  

  return (
    <div className="topbar d-flex justify-content-end align-items-center px-4 py-2 bg-light border-bottom">
      <div className="admin-info d-flex align-items-center gap-3">
        <i className="fa fa-user" /> <span>Admin</span>
        <button className="btn btn-outline-success fw-bold btn-sm" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Topbar;
